/**
 * Checks whether a file satisfies an `accept` string (the same syntax as the
 * HTML `<input accept="...">` attribute). The native `accept` attribute only
 * filters the browse dialog, so this is used to enforce the same rules for
 * drag-and-dropped files.
 *
 * Supported tokens (comma-separated):
 * - extensions: `.pdf`, `.csv`
 * - wildcard MIME types: `image/*`, `video/*`
 * - exact MIME types: `application/pdf`, `text/plain`
 */
export const isFileAccepted = (file: File, accept?: string): boolean => {
  if (!accept || accept.trim() === '') {
    return true;
  }

  const acceptTokens = accept
    .split(',')
    .map(token => token.trim().toLowerCase())
    .filter(Boolean);

  if (acceptTokens.length === 0) {
    return true;
  }

  const fileName = file.name.toLowerCase();
  const mimeType = file.type.toLowerCase();

  return acceptTokens.some(token => {
    if (token.startsWith('.')) {
      return fileName.endsWith(token);
    }

    if (token.endsWith('/*')) {
      const baseType = token.slice(0, token.indexOf('/'));

      return !!mimeType && mimeType.startsWith(`${baseType}/`);
    }

    return mimeType === token;
  });
};
